import React, { useState } from "react";

import classes from "./styles/style.module.css";
import CustomInput from "../../assets/components/customInput";

const TextFieldElement = ({
  id,
  title,
  subtitle,
  desc,
  placeholder,
  value,
  handleChange,
  req,
  type,
}) => {
  const [error, setError] = useState(false);

  const validatePhoneNumber = (phone) => {
    const regex = /^(\+98|0)?9\d{9}$/;
    return regex.test(phone);
  };

  const handleInputChange = (value) => {
    if (type === "tel") {
      const isValid = validatePhoneNumber(value);
      setError(!isValid);
    }
    handleChange(id, value);
  };

  return (
    <div className="my-4">
      <p className={classes.formTitle}>
        {title} <span className="text-danger">{req ? "*" : null}</span>
      </p>
      <div className="px-2">
        {subtitle && <p className={classes.subTitle}>{subtitle}</p>}
        <CustomInput
          label={""}
          placeholder={placeholder}
          value={value}
          handleChange={handleInputChange}
          name="name"
          type={type}
          isPhone={type === "tel"}
        />
        {error && <p className="text-danger">شماره موبایل معتبر نیست</p>}
        {desc && <p className={classes.desc}>{desc}</p>}
      </div>
    </div>
  );
};

export default TextFieldElement;
